import React from "react";
import styles from "./Appbar.module.css";
import MaterialIconsReact from "material-icons-react";
import { useLocation, useNavigate } from "react-router";

const Appbar = (props) => {
  const { navigateTo, title, subTitle, goBack } = props || {};
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className={styles.header}>
      <div className={styles.leftSection}>
        <MaterialIconsReact
          icon="arrow_back"
          color={"#666666"}
          size={20}
          onClick={() =>
            !!location?.state?.from && goBack
              ? navigate(-1)
              : navigate(navigateTo)
          }
        />
        <div className={styles.headerText}>
          {props.subTitle ? (
            <div className={styles.subTitle}>{subTitle}</div>
          ) : null}
          <div className={styles.title}>{title}</div>
        </div>
      </div>
      <div>{props.right}</div>
    </div>
  );
};

export default Appbar;
